import { render, staticRenderFns } from "./LowMovingStockCard.vue?vue&type=template&id=2b8c5eb7&"
import script from "./LowMovingStockCard.vue?vue&type=script&lang=js&"
export * from "./LowMovingStockCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports